import { UPDATE_VENDOR, VendorActionTypes, VendorState } from './types';

export function updateVendor(newState: VendorState): VendorActionTypes {
  return {
    type: UPDATE_VENDOR,
    payload: newState
  };
}
